import { Check, ChevronDown } from "lucide-react";
import React, { useEffect, useState } from "react";
import "./ChooseGift.css";

export const ChooseGift = () => {
  const imageUrl = "https://csa-widget.chargezen.workers.dev";

  const [box, setBox] = useState(true);

  const chargezenProduct = window.chargezenProduct;

  const toggleBoxes = () => {
    //change the state of box1
    setBox(!box);
  };

  const pickupLocation = [
    "GARDINER BAKEHOUSE",
    "WELLNESS EMBODIED",
    "HUGUENOT FARM CSA",
    "PHILLIES BRIDGE FARM CSA",
    "TALIAFERRO FARM CSA",
  ];

  const [pickupDayArray, setPickupDayArray] = useState([]);

  const pickupDay = {
    0: ["Tuesday", "Friday"],
    1: ["Wednesday"],
    2: ["Thursday"],
    3: ["Tuesday", "Saturday"],
    4: ["Thursday", "Friday", "Saturday"],
  };

  const [select1, setSelect1] = useState(pickupLocation[0]);

  const [select2, setSelect2] = useState("Tuesday");

  const [select3, setSelect3] = useState("Bread of the month");

  const [select4, setSelect4] = useState("12 Weeks");

  const [isHidden, setIsHidden] = useState(true);

  const [isHidden2, setIsHidden2] = useState(true);

  const [isHidden3, setIsHidden3] = useState(true);

  const [isHidden4, setIsHidden4] = useState(true);

  const productOptions = [
    "Bakehouse Sourdough",
    "Bread of the Week",
    "Pastry Box",
  ];

  const toggleSelect1 = (event) => {
    const target = event.target.textContent;

    setSelect1(target);

    //close the select box
    setIsHidden(!isHidden);

    switch (target) {
      case "GARDINER BAKEHOUSE":
        setPickupDayArray(pickupDay[0]);
        setSelect2(pickupDay[0][0]);
        break;

      case "WELLNESS EMBODIED":
        setPickupDayArray(pickupDay[1]);
        setSelect2(pickupDay[1][0]);
        break;

      case "HUGUENOT FARM CSA":
        setPickupDayArray(pickupDay[2]);
        setSelect2(pickupDay[2][0]);
        break;

      case "PHILLIES BRIDGE FARM CSA":
        setPickupDayArray(pickupDay[3]);
        setSelect2(pickupDay[3][0]);
        break;

      case "TALIAFERRO FARM CSA":
        setPickupDayArray(pickupDay[4]);
        setSelect2(pickupDay[4][0]);
        break;

      default:
        setPickupDayArray(pickupDay[0]);
        setSelect2(pickupDay[0][0]);
        break;
    }
  };

  const toggleSelect2 = (event) => {
    const target = event.target.textContent;

    setSelect2(target);

    //close the select box
    setIsHidden2(!isHidden2);
  };

  const toggleSelect3 = (event) => {
    const target = event.target.textContent;

    setSelect3(target);

    //close the select box
    setIsHidden3(!isHidden3);
  };

  const toggleSelect4 = (event) => {
    const target = event.target.textContent;

    setSelect4(target);

    //close the select box
    setIsHidden4(!isHidden4);
  };

  useEffect(() => setPickupDayArray(pickupDay[0]), []);

  return (
    <div className="containers">
      <div className="one">
        <div className="header">
          <div className="radio mt-1">
            <input
              onChange={toggleBoxes}
              id="radio-2"
              name="save"
              type="radio"
              checked={box === false}
            />
            <label htmlFor="radio-2" className="radio-label"></label>
          </div>
          <span className="radio-span">
            Let's configure your Bakehouse Membership
          </span>
        </div>
      </div>

      {box === false && (
        <div className="inner-container">
          <div className="select-container">
            <div className="w-full">
              <label className="pickup-label">PICKUP LOCATIONS</label>
              <div className="w-full relative">
                <div
                  onClick={() => setIsHidden(!isHidden)}
                  className="pickup-container"
                >
                  <span className="text-base">{select1}</span>{" "}
                  <span className="select-arrow p-0"></span>
                </div>
                <div className={`${isHidden && "hidden"}`}>
                  <ul className="pickup-unordered">
                    {pickupLocation.map((loc, index) => {
                      return (
                        <li
                          onClick={toggleSelect1}
                          key={index}
                          className="pickup-list"
                        >
                          {loc}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="w-full">
              <label className="pickupday-label">PICK UP DAY</label>
              <div className="w-full relative">
                <div
                  onClick={() => setIsHidden2(!isHidden2)}
                  className="pickup-container"
                >
                  <span className="text-base">{select2}</span>{" "}
                  <span className="select-arrow p-0"></span>
                </div>
                <div className={`${isHidden2 && "hidden"}`}>
                  <ul className="pickup-unordered">
                    {pickupDayArray.map((day, index) => {
                      return (
                        <li
                          onClick={toggleSelect2}
                          key={index}
                          className="pickup-list"
                        >
                          {day}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="px54">
            <div className="w-full mt-0 md:mt-0">
              <label className="pickup-label">PRODUCT</label>
              <div className="w-full relative">
                <div
                  onClick={() => setIsHidden3(!isHidden3)}
                  className="pickup-container"
                >
                  <span className="text-base">{select3}</span>{" "}
                  <span className="select-arrow p-0"></span>
                </div>
                <div className={`${isHidden3 && "hidden"}`}>
                  <ul className="pickup-unordered">
                    {productOptions.map((product, index) => {
                      return (
                        <li
                          onClick={toggleSelect3}
                          key={index}
                          className="pickup-list"
                        >
                          {product}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="w-full mt-5">
              <label className="pickup-label">SUBSCRIPTION LENGTH</label>
              <div className="w-full relative">
                <div
                  onClick={() => setIsHidden4(!isHidden4)}
                  className="pickup-container"
                >
                  <span className="text-base">{select4}</span>{" "}
                  <span className="select-arrow p-0"></span>
                </div>
                <div className={`${isHidden4 && "hidden"}`}>
                  <ul className="pickup-unorderd">
                    <li onClick={toggleSelect4} className="pickup-list">
                      12 Weeks
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="p-5 px-3">
            <div className="coffee-small">
              <div>
                <small>This coffee is part of our</small>
                <h3>The Medium Roast Coffee Collection</h3>
                <small>44 Coffees</small>
              </div>
              <div>
                <img src={`${imageUrl}/MEDIUM_ROAST_300x300.png`} alt="book" />
              </div>
            </div>

            <div className="mt-3">
              <div className="collection">
                <div>
                  <h3 className=" font-bold">Subscribe to Collection</h3>
                </div>
                <div>
                  <h3 className=" font-bold">More Info</h3>
                </div>
              </div>
              <ul className="ul-collection">
                <li className=" text-slate-700">
                  <span>
                    <svg
                      width="12"
                      className="inline"
                      height="8"
                      viewBox="0 0 12 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.8816 0.6257C11.0423 0.79041 11.039 1.05421 10.8743 1.21491L4.61041 7.32602C4.44854 7.48394 4.19024 7.48391 4.02841 7.32595L1.12563 4.49269C0.960953 4.33195 0.957756 4.06816 1.11849 3.90348C1.27923 3.7388 1.54302 3.7356 1.7077 3.89634L4.31951 6.4456L10.2924 0.61842C10.4571 0.457727 10.7209 0.460984 10.8816 0.6257Z"
                        fill="#1A1A1A"
                        stroke="#1A1A1A"
                        strokeWidth="0.3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <small className="inline ml-3">
                    Explore a new coffe in every delivery
                  </small>
                </li>
                <li className=" text-slate-700">
                  <span>
                    <svg
                      width="12"
                      className="inline"
                      height="8"
                      viewBox="0 0 12 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.8816 0.6257C11.0423 0.79041 11.039 1.05421 10.8743 1.21491L4.61041 7.32602C4.44854 7.48394 4.19024 7.48391 4.02841 7.32595L1.12563 4.49269C0.960953 4.33195 0.957756 4.06816 1.11849 3.90348C1.27923 3.7388 1.54302 3.7356 1.7077 3.89634L4.31951 6.4456L10.2924 0.61842C10.4571 0.457727 10.7209 0.460984 10.8816 0.6257Z"
                        fill="#1A1A1A"
                        stroke="#1A1A1A"
                        strokeWidth="0.3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <small className="inline ml-3">
                    Manage your ccoffe queue and frequency
                  </small>
                </li>
                <li className=" text-slate-700">
                  <span>
                    <svg
                      width="12"
                      className="inline"
                      height="8"
                      viewBox="0 0 12 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.8816 0.6257C11.0423 0.79041 11.039 1.05421 10.8743 1.21491L4.61041 7.32602C4.44854 7.48394 4.19024 7.48391 4.02841 7.32595L1.12563 4.49269C0.960953 4.33195 0.957756 4.06816 1.11849 3.90348C1.27923 3.7388 1.54302 3.7356 1.7077 3.89634L4.31951 6.4456L10.2924 0.61842C10.4571 0.457727 10.7209 0.460984 10.8816 0.6257Z"
                        fill="#1A1A1A"
                        stroke="#1A1A1A"
                        strokeWidth="0.3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <small className="inline ml-3">Delay or cancel anytime</small>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      <button className="button-primary w-full">Add To Cart</button>

      <p className="last-p">
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className="inline"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 2.22097C9.45427 2.22097 7.39056 4.28467 7.39056 6.83037C7.39056 9.37607 9.45427 11.4398 12 11.4398C14.5457 11.4398 16.6094 9.37607 16.6094 6.83037C16.6094 4.28467 14.5457 2.22097 12 2.22097ZM6.94889 6.83037C6.94889 4.04074 9.21035 1.7793 12 1.7793C14.7896 1.7793 17.0511 4.04074 17.0511 6.83037C17.0511 9.62 14.7896 11.8814 12 11.8814C9.21035 11.8814 6.94889 9.62 6.94889 6.83037ZM10.1937 5.74605C9.59461 5.74605 9.10907 6.23197 9.10907 6.83069C9.10907 7.4298 9.595 7.91534 10.1937 7.91534C10.3157 7.91534 10.4146 8.01421 10.4146 8.13618C10.4146 8.25814 10.3157 8.35701 10.1937 8.35701C9.35118 8.35701 8.6674 7.67384 8.6674 6.83069C8.6674 5.98814 9.35058 5.30438 10.1937 5.30438H12.4118L12.2173 5.10985C12.1311 5.02361 12.1311 4.88379 12.2173 4.79755C12.3036 4.7113 12.4434 4.7113 12.5296 4.79755L13.1017 5.36964L13.2579 5.5258L13.1017 5.68195L12.5296 6.25405C12.4434 6.34029 12.3036 6.34029 12.2173 6.25405C12.1311 6.16781 12.1311 6.02798 12.2173 5.94174L12.413 5.74605H10.1937ZM13.8046 5.30545C13.6827 5.30545 13.5838 5.40433 13.5838 5.52629C13.5838 5.64825 13.6827 5.74712 13.8046 5.74712C14.4034 5.74712 14.8893 6.23266 14.8893 6.83177C14.8893 7.4305 14.4037 7.91642 13.8046 7.91642H11.6578L11.8539 7.72038C11.9401 7.63414 11.9401 7.49432 11.8539 7.40808C11.7676 7.32183 11.6278 7.32183 11.5416 7.40808L10.9694 7.98017L10.8133 8.13633L10.9694 8.29248L11.5416 8.86458C11.6278 8.95082 11.7676 8.95082 11.8539 8.86458C11.9401 8.77834 11.9401 8.63851 11.8539 8.55227L11.6597 8.35809H13.8046C14.6478 8.35809 15.3309 7.67432 15.3309 6.83177C15.3309 5.98862 14.6472 5.30545 13.8046 5.30545ZM5.83039 11.884C3.28468 11.884 1.22097 13.9477 1.22097 16.4934C1.22097 19.0391 3.28468 21.1028 5.83039 21.1028C8.37611 21.1028 10.4398 19.0391 10.4398 16.4934C10.4398 13.9477 8.37611 11.884 5.83039 11.884ZM0.779297 16.4934C0.779297 13.7038 3.04075 11.4423 5.83039 11.4423C8.62003 11.4423 10.8815 13.7038 10.8815 16.4934C10.8815 19.283 8.62003 21.5445 5.83039 21.5445C3.04075 21.5445 0.779297 19.283 0.779297 16.4934ZM4.54009 14.337C4.54009 14.215 4.44121 14.1161 4.31925 14.1161C4.19729 14.1161 4.09841 14.215 4.09841 14.337V18.6505C4.09841 18.7725 4.19729 18.8713 4.31925 18.8713C4.44121 18.8713 4.54009 18.7725 4.54009 18.6505V14.337ZM7.34074 14.1162C7.4627 14.1162 7.56157 14.215 7.56157 14.337V18.6505C7.56157 18.7725 7.4627 18.8714 7.34074 18.8714C7.21877 18.8714 7.1199 18.7725 7.1199 18.6505V14.337C7.1199 14.215 7.21877 14.1162 7.34074 14.1162ZM13.5608 16.4933C13.5608 13.9476 15.6245 11.8839 18.1702 11.8839C20.7159 11.8839 22.7797 13.9476 22.7797 16.4933C22.7797 19.039 20.7159 21.1027 18.1702 21.1027C15.6245 21.1027 13.5608 19.039 13.5608 16.4933ZM18.1702 11.4423C15.3806 11.4423 13.1191 13.7037 13.1191 16.4933C13.1191 19.283 15.3806 21.5444 18.1702 21.5444C20.9599 21.5444 23.2213 19.283 23.2213 16.4933C23.2213 13.7037 20.9599 11.4423 18.1702 11.4423ZM17.8896 14.0267C17.9758 13.9404 18.1157 13.9404 18.2019 14.0267L20.5119 16.3366L20.668 16.4928L20.5119 16.6489L18.2019 18.9594C18.1157 19.0456 17.9759 19.0457 17.8896 18.9594C17.8034 18.8732 17.8033 18.7334 17.8896 18.6471L20.0434 16.4928L17.8896 14.339C17.8033 14.2527 17.8033 14.1129 17.8896 14.0267ZM16.3737 14.0266C16.2875 13.9403 16.1477 13.9403 16.0614 14.0266C15.9752 14.1128 15.9752 14.2526 16.0614 14.3389L18.2153 16.4927L16.0614 18.647C15.9752 18.7332 15.9752 18.8731 16.0614 18.9593C16.1477 19.0455 16.2875 19.0455 16.3738 18.9593L18.6837 16.6488L18.8398 16.4927L18.6837 16.3365L16.3737 14.0266Z"
              fill="#1A1A1A"
            ></path>
          </svg>
        </span>{" "}
        &nbsp; Easily customize, pause, or cancel at anytime
      </p>
    </div>
  );
};
